import { render, staticRenderFns } from "./rootsInSoil.vue?vue&type=template&id=791d4efc&scoped=true"
import script from "./rootsInSoil.vue?vue&type=script&lang=js"
export * from "./rootsInSoil.vue?vue&type=script&lang=js"
import style0 from "./rootsInSoil.vue?vue&type=style&index=0&id=791d4efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d4efc",
  null
  
)

export default component.exports